var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-success-thank-you.d612855f.png","uri@2x": __webpack_public_path__ + "icon-success-thank-you.cab38dd4.png","uri@3x": __webpack_public_path__ + "icon-success-thank-you.88f0427e.png",
    width: 37,
    height: 37
});